import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=3488ac20&scoped=true"
import script from "./fileUpload.vue?vue&type=script&lang=js"
export * from "./fileUpload.vue?vue&type=script&lang=js"
import style0 from "./fileUpload.vue?vue&type=style&index=0&id=3488ac20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488ac20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3488ac20')) {
      api.createRecord('3488ac20', component.options)
    } else {
      api.reload('3488ac20', component.options)
    }
    module.hot.accept("./fileUpload.vue?vue&type=template&id=3488ac20&scoped=true", function () {
      api.rerender('3488ac20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/fileUpload.vue"
export default component.exports